import {setSegment} from '../utils/utils';
import acceptedCookiePolicy from "./onetrust/cookiePolicy";
import Cookies from "js-cookie";

/**
 * Push data in Google Analytics
 * @param config.$form - current form
 * @param config.isInModal - return if the form is in modal
 */
const dataLayerData = (config = {}) => {
    acceptedCookiePolicy({
        ifTargetingCookies: () => {
            const $form = config.form || null;
            const isInModal = config.isInModal || false;
            const isGated = config.isGated || $form && $form.hasClass('gated') || false;

            const segment = setSegment();
            let leadCategory = '';

            if (Cookies.get('marketo_id')) {
                leadCategory = 'existing lead';
            } else {
                if (!isGated) {
                    leadCategory = 'anonymous lead';
                } else {
                    leadCategory = 'new lead';
                }
            }

            console.log(`accessAssets_${segment}`)

            if (typeof dataLayer !== 'undefined') {
                if(isInModal) {
                    if(!$('[data-modal="form"]').hasClass('show-success-message')) {
                        dataLayerBus.push({
                            'eventCategory': 'view asset',
                            'eventAction': `accessAssets_${segment}`,
                            'eventLabel': leadCategory,
                            'event': `accessAssets_`
                        });
                    }
                } else {
                    dataLayerBus.push({
                        'eventCategory': 'view asset',
                        'eventAction': `accessAssets_${segment}`,
                        'eventLabel': leadCategory,
                        'event': `accessAssets_`
                    });
                }
            }
        }
    });
};

/**
 * Send tracking data to Google Analytics on button click inside a form
 */
const trackingCTA = () => {
    const $btnViewResource = $('#resources_details button');
    const $ctaBannerButton = $('.cta-banner-resource-document .button');
    const $errorMessage = $('.error-message');

    $btnViewResource.on('click', function() {
        const $form = $(this).closest('form');
        let isInModal = false;

       setTimeout(() => {
           if(!$errorMessage.length) {
               if($form.closest('[data-modal="form"]').length) {
                   isInModal = true;
               }

               if($form.find('[name="Email"]').val() !== '' && $form.hasClass('allow-download')) {
                   dataLayerData({
                       form: $form,
                       isInModal
                   });
               }
           }
       }, 500);
    });

    $ctaBannerButton.on('click', function() {
        setTimeout(() => {
            if(!$errorMessage.length) {
                if ($('.triggers-zone form.not-gated').length) {
                    dataLayerData();
                }
            }
        }, 500);
    });
};

const initResourcesTracking = () => {
    acceptedCookiePolicy({
        ifTargetingCookies: () => {
            trackingCTA();
        }
    });
};

export default initResourcesTracking;
export { dataLayerData };